import { needDetailFieldPlaceholderSet } from './constants';
import { ChurnReason } from './types';

export const canSendForm = (reason: ChurnReason | null) => {
  if (!reason) {
    return false;
  }
  if (Object.keys(needDetailFieldPlaceholderSet).includes(reason.mainReason)) {
    return !!reason.detailReason;
  }
  return true;
};

export const getReasonText = (
  reason: ChurnReason | null,
  status?: string,
  where?: 'beforePaywall' | 'afterPaywall'
) => {
  if (!reason) {
    return '';
  }

  const paywallText = where ? (where === 'beforePaywall' ? 'on paywall' : 'after paywall') : '';
  const whereSuffix = paywallText ? `, ${paywallText}` : '';

  return `${reason.mainReason} - ${reason.detailReason} (status: ${status || 'Before trial'} - Web${whereSuffix})`;
};
